const isDeployment = true;


//const isDeployment = process.env.NODE_ENV === 'deployment';

// In web builds, NODE_ENV should be "development" for local dev server and "production" for builds.
// Prefer explicit local dev URL when not in production.
const apiUrl = isDeployment
    ? (process.env.REACT_APP_DEPLOY_API_URL)
    : (process.env.REACT_APP_API_URL);

// export const constants = {
//     API_URL: 'https://mimemateria.com',
//     SOCKET_URL: '/io',
//     GOOGLE_CLIENT_ID: '153910581280-gn1a1trjg94odg5ku49ic2crortk2tcc.apps.googleusercontent.com'
// };  



export const constants = {
    API_URL: apiUrl,
    SOCKET_URL: '/io',
    GOOGLE_CLIENT_ID: '153910581280-gn1a1trjg94odg5ku49ic2crortk2tcc.apps.googleusercontent.com',
    MOBILE_APK_URL: 'https://beta.figshelf.com/releases/Figshelf-Beta.apk'
};  

// export const constants = {
//     API_URL: 'https://figshelf.site',
//     SOCKET_URL: 'https://figshelf.site',
//     GOOGLE_CLIENT_ID: '153910581280-gn1a1trjg94odg5ku49ic2crortk2tcc.apps.googleusercontent.com'
// };  

// export const constants = {
//     API_URL: 'https://figshelf.site',
//     SOCKET_URL: 'https://figshelf.site',
//     GOOGLE_CLIENT_ID: '153910581280-gn1a1trjg94odg5ku49ic2crortk2tcc.apps.googleusercontent.com'
// };  